import { PipeTransform, Pipe } from '@angular/core';
import { enumToList } from '../enum-to-list';
import { ProgramFilter } from 'src/app/shared/enums/program-filter.enum';
import { IdName } from 'src/app/shared/models/id-name.model';

@Pipe({
  name: 'programFilter',
  standalone: false
})
export class ProgramFilterPipe implements PipeTransform {
  public transform(value: ProgramFilter): string {
    return getProgramFilter(value);
  }
}

export function getProgramFilter(value: ProgramFilter): string {
  switch (value) {
    case ProgramFilter.None:
      return 'None';
    case ProgramFilter.NotificationsOnly:
      return 'Limit notifications only';
    case ProgramFilter.AccessAndNotifications:
      return 'Limit access and notifications';
    default:
      throw new Error(`Unsupported value for ProgramFilter: ${value}.`);
  }
}

export function getProgramFilterList(): IdName[] {
  return enumToList(ProgramFilter, getProgramFilter);
}
